import axios from 'axios'

export default {
  namespaced: true,
  state: {
    lista: [],
    filtroDescricao: '',
    filtroProdutoId: null,
    filtroSituacao: '1',
    registroSelecionadoId: null,
    paginaAtual: 1,
    recarregarLista: false,
    formulaAtual: null,
    itensFormula: []
  },
  getters: {
    LISTA: state => state.lista,
    FILTRO_DESCRICAO: state => state.filtroDescricao,
    FILTRO_PRODUTO_ID: state => state.filtroProdutoId,
    FILTRO_SITUACAO: state => state.filtroSituacao,
    REGISTRO_SELECIONADO_ID: state => state.registroSelecionadoId,
    PAGINA_ATUAL: state => state.paginaAtual,
    RECARREGAR_LISTA: state => state.recarregarLista,
    FORMULA_ATUAL: state => state.formulaAtual,
    ITENS_FORMULA: state => state.itensFormula
  },
  mutations: {
    SET_LISTA(state, payload) {
      state.lista = payload
    },
    SET_FILTRO_DESCRICAO(state, payload) {
      state.filtroDescricao = payload
    },
    SET_FILTRO_PRODUTO_ID(state, payload) {
      state.filtroProdutoId = payload
    },
    SET_FILTRO_SITUACAO(state, payload) {
      state.filtroSituacao = payload
    },
    SET_REGISTRO_SELECIONADO_ID(state, payload) {
      state.registroSelecionadoId = payload
    },
    SET_PAGINA_ATUAL(state, payload) {
      state.paginaAtual = payload
    },
    SET_RECARREGAR_LISTA(state, payload) {
      state.recarregarLista = payload
    },
    SET_FORMULA_ATUAL(state, payload) {
      state.formulaAtual = payload
    },
    SET_ITENS_FORMULA(state, payload) {
      state.itensFormula = payload
    },
    SET_LIMPAR(state) {
      state.filtroDescricao = ''
      state.filtroProdutoId = null
      state.filtroSituacao = '1'
      state.paginaAtual = 1
    }
  },
  actions: {
    async GET_LISTA(context) {
      const params = {
        descricao: context.state.filtroDescricao,
        produtoId: context.state.filtroProdutoId,
        situacao: context.state.filtroSituacao
      }
      const { data } = await axios.get('/api/protected/producao-formula/pesquisar', { params })
      context.commit('SET_LISTA', data)
      return data
    },
    async GET_BY_ID(context, id) {
      const { data } = await axios.get(`/api/protected/producao-formula/getById/${id}`)
      context.commit('SET_FORMULA_ATUAL', data[0] || null)
      return data[0] || null
    },
    async GET_ITENS(context, formulaId) {
      const { data } = await axios.get(`/api/protected/producao-formula-item/listar/${formulaId}`)
      context.commit('SET_ITENS_FORMULA', data)
      return data
    }
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/producao-formula-store.js